export enum LikeParentType {
    Question = 'Question',
    CommunityPost = 'CommunityPost',
    Thread = 'Thread',
}
